<template>
  <nav class="navbar" :class="{ 'navbar-sticky': isScrolled }">
    <router-link
      to="/activities"
      class="announcement-banner"
      v-if="layoutStore.showAnnouncementBanner"
    >
      <div class="announcement-content">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_1971_2489"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9"></rect>
          </mask>
          <g mask="url(#mask0_1971_2489)">
            <path
              d="M16 13V11H20V13H16ZM17.2 20L14 17.6L15.2 16L18.4 18.4L17.2 20ZM15.2 8L14 6.4L17.2 4L18.4 5.6L15.2 8ZM3 15V9H7L12 4V20L7 15H3Z"
              fill="#FFF9B9"
            ></path>
          </g>
        </svg>
        <span class="announcement-text"
          ><u
            >本站註冊服務將於 2026/2/24（二）00:00-02:00 與
            2026/3/3（二）00:00-03:00 暫停</u
          ></span
        >
      </div>
    </router-link>
    <div class="container">
      <!-- Logo 區塊 -->
      <div class="logo-section">
        <!-- 跳至主要內容快速鍵 (Tab 第一鍵進入，Enter 直達主要內容) -->
        <a
          href="#main-content"
          class="skip-to-content-link"
          @click="focusMainContent"
        >
          跳至主要內容區塊 (Skip to main content)
        </a>
        <!-- 上方導覽磚 (Alt + U)：低調水平平行於 Logo，Tab 鍵聚焦時清晰顯現 -->
        <a
          id="accesskey-u"
          href="#accesskey-u"
          accesskey="U"
          class="accesskey-brick"
          title="上方導覽連結區塊，快捷鍵：Alt+U"
          aria-label="上方導覽連結區塊"
        >:::</a>
        <router-link to="/home" title="返回首頁">
          <img src="/platform_logo.svg" :alt="`${SITE_NAME} 首頁`" />
        </router-link>
      </div>
      <!-- 桌機版選單 左側 -->
      <div class="nav-items nav-left desktop-only">
        <!-- 最新消息 -->
        <router-link to="/activities" class="nav-item">{{
          $t("navbar.latestNews")
        }}</router-link>

        <!-- 簡介與沿革 -->
        <a-dropdown v-model:open="dropdownOpen.intro" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu" role="menu" data-menu="intro" :aria-label="$t('navbar.platformIntro')">
              <router-link to="/minister-intro" class="dropdown-item" role="menuitem" @click="dropdownOpen.intro = false" @keydown="handleMenuItemKeyDown('intro', $event)">{{
                $t("navbar.ministerIntro")
              }}</router-link>
              <router-link to="/vice-minister-intro" class="dropdown-item" role="menuitem" @click="dropdownOpen.intro = false" @keydown="handleMenuItemKeyDown('intro', $event)">{{
                $t("navbar.viceMinisterIntro")
              }}</router-link>
              <router-link to="/director-intro" class="dropdown-item" role="menuitem" @click="dropdownOpen.intro = false" @keydown="handleMenuItemKeyDown('intro', $event)">{{
                $t("navbar.directorIntro")
              }}</router-link>
            </div>
          </template>
          <button
            type="button"
            class="nav-item dropdown-trigger btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.intro"
            data-trigger="intro"
            @keydown="handleTriggerKeyDown('intro', $event)"
          >
            <span>{{ $t("navbar.platformIntro") }}</span>
            <DownOutlined class="down-icon" aria-hidden="true" />
          </button>
        </a-dropdown>

        <!-- SNOMED CT介紹 -->
        <a-dropdown v-model:open="dropdownOpen.standard" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu" role="menu" data-menu="standard" :aria-label="$t('navbar.snomedCtIntro')">
              <router-link to="/snomed-ct" class="dropdown-item" role="menuitem" @click="dropdownOpen.standard = false" @keydown="handleMenuItemKeyDown('standard', $event)">{{
                $t("navbar.whatIsSnomedCt")
              }}</router-link>
              <router-link to="/snomed-ct-education" class="dropdown-item" role="menuitem" @click="dropdownOpen.standard = false" @keydown="handleMenuItemKeyDown('standard', $event)">{{
                $t("navbar.snomedCtEducation")
              }}</router-link>
            </div>
          </template>
          <button
            type="button"
            class="nav-item dropdown-trigger btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.standard"
            data-trigger="standard"
            @keydown="handleTriggerKeyDown('standard', $event)"
          >
            <span>{{ $t("navbar.snomedCtIntro") }}</span>
            <DownOutlined class="down-icon" aria-hidden="true" />
          </button>
        </a-dropdown>

        <!-- 培訓認證 -->
        <a-dropdown v-model:open="dropdownOpen.training" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu" role="menu" data-menu="training" :aria-label="$t('navbar.training')">
              <router-link to="/workshop-courses" class="dropdown-item" role="menuitem" @click="dropdownOpen.training = false" @keydown="handleMenuItemKeyDown('training', $event)">{{
                $t("navbar.workshopCourses")
              }}</router-link>
              <router-link to="/workshop-materials" class="dropdown-item" role="menuitem" @click="dropdownOpen.training = false" @keydown="handleMenuItemKeyDown('training', $event)">{{
                $t("navbar.workshopMaterials")
              }}</router-link>
              <router-link to="/certification-apply" class="dropdown-item" role="menuitem" @click="dropdownOpen.training = false" @keydown="handleMenuItemKeyDown('training', $event)">{{
                $t("navbar.certificationApply")
              }}</router-link>
            </div>
          </template>
          <button
            type="button"
            class="nav-item dropdown-trigger btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.training"
            data-trigger="training"
            @keydown="handleTriggerKeyDown('training', $event)"
          >
            <span>{{ $t("navbar.training") }}</span>
            <DownOutlined class="down-icon" aria-hidden="true" />
          </button>
        </a-dropdown>

        <!-- 臺灣標準 -->
        <a-dropdown v-model:open="dropdownOpen.taiwan" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu" role="menu" data-menu="taiwan" :aria-label="$t('navbar.taiwanStandards')">
              <router-link to="/standard-announcements" class="dropdown-item" role="menuitem" @click="dropdownOpen.taiwan = false" @keydown="handleMenuItemKeyDown('taiwan', $event)">{{
                $t("navbar.standardAnnouncements")
              }}</router-link>
            </div>
          </template>
          <button
            type="button"
            class="nav-item dropdown-trigger btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.taiwan"
            data-trigger="taiwan"
            @keydown="handleTriggerKeyDown('taiwan', $event)"
          >
            <span>{{ $t("navbar.taiwanStandards") }}</span>
            <DownOutlined class="down-icon" aria-hidden="true" />
          </button>
        </a-dropdown>

        <!-- 支援中心 -->
        <router-link to="/customer-service" class="nav-item">{{
          $t("navbar.supportCenter")
        }}</router-link>
      </div>

      <!-- 桌機版選單 右側 -->
      <div class="nav-items nav-right desktop-only">
        <!-- 計劃網站 -->
        <a-dropdown v-model:open="dropdownOpen.project" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu project-websites-menu" role="menu" data-menu="project" :aria-label="$t('navbar.projectWebsites')">
              <a
                :href="PROJECT_WEBSITE_LINKS.medStandard"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectMedStandard')} (另開新視窗)`"
              >
                {{ $t("navbar.projectMedStandard") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.thds"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectThds')} (另開新視窗)`"
              >
                {{ $t("navbar.projectThds") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.thrs"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectThrs')} (另開新視窗)`"
              >
                {{ $t("navbar.projectThrs") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.thas"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectThas')} (另開新視窗)`"
              >
                {{ $t("navbar.projectThas") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.snomedCt"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectSnomedCt')} (另開新視窗)`"
              >
                {{ $t("navbar.projectSnomedCt") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.loinc"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectLoinc')} (另開新視窗)`"
              >
                {{ $t("navbar.projectLoinc") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.rxnorm"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectRxNorm')} (另開新視窗)`"
              >
                {{ $t("navbar.projectRxNorm") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.smartHealth"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectSmartHealth')} (另開新視窗)`"
              >
                {{ $t("navbar.projectSmartHealth") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.aiCenter"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectAiCenter')} (另開新視窗)`"
              >
                {{ $t("navbar.projectAiCenter") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.aiCenter1"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectAiCenter1')} (另開新視窗)`"
              >
                {{ $t("navbar.projectAiCenter1") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
              <a
                :href="PROJECT_WEBSITE_LINKS.aiCenter2"
                target="_blank"
                rel="noopener noreferrer"
                class="dropdown-item"
                role="menuitem"
                @click="dropdownOpen.project = false"
                @keydown="handleMenuItemKeyDown('project', $event)"
                :title="`${$t('navbar.projectAiCenter2')} (另開新視窗)`"
              >
                {{ $t("navbar.projectAiCenter2") }}
                <span class="sr-only visually-hidden">(另開新視窗)</span>
                <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33333 0C0.604625 0 0 0.604625 0 1.33333V10.6667C0 11.3954 0.604625 12 1.33333 12H10.6667C11.3954 12 12 11.3954 12 10.6667V6H10.6667V10.6667H1.33333V1.33333H6V0H1.33333ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z" fill="black"/></svg>
              </a>
            </div>
          </template>
          <button
            type="button"
            class="nav-item dropdown-trigger btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.project"
            data-trigger="project"
            @keydown="handleTriggerKeyDown('project', $event)"
          >
            <span>{{ $t("navbar.projectWebsites") }}</span>
            <DownOutlined class="down-icon" aria-hidden="true" />
          </button>
        </a-dropdown>
      </div>
      <div v-if="isLoggedIn" class="button-group desktop-only">
        <a-dropdown v-model:open="dropdownOpen.user" :trigger="['hover', 'click']">
          <template #overlay>
            <div class="dropdown-menu user-menu" role="menu" data-menu="user" :aria-label="$t('navbar.myAccount')">
              <router-link to="/dashboard" class="dropdown-item" role="menuitem" @click="dropdownOpen.user = false" @keydown="handleMenuItemKeyDown('user', $event)">
                {{ $t("navbar.dashboard") }}
              </router-link>
              <router-link to="/ProfileEdit" class="dropdown-item" role="menuitem" @click="dropdownOpen.user = false" @keydown="handleMenuItemKeyDown('user', $event)">
                {{ $t("navbar.profile") }}
              </router-link>
              <div class="dropdown-divider"></div>
              <button type="button" class="dropdown-item logout btn-reset" role="menuitem" @click="handleLogout" @keydown="handleMenuItemKeyDown('user', $event)">
                {{ $t("navbar.logout") }}
              </button>
            </div>
          </template>
          <button
            type="button"
            class="user-profile-btn btn-reset"
            aria-haspopup="true"
            :aria-expanded="dropdownOpen.user"
            data-trigger="user"
            @keydown="handleTriggerKeyDown('user', $event)"
          >
            <span v-if="userData && userData.name" class="user-name">{{
              userData.name
            }}</span>
            <span v-else class="user-name">{{ $t("navbar.myAccount") }}</span>
            <img
              v-if="userData && userData.avatar"
              :src="userData.avatar"
              :alt="userData.name || '用戶頭像'"
              class="user-avatar"
            />
            <div v-else class="user-avatar-placeholder">
              <UserOutlined />
            </div>
          </button>
        </a-dropdown>
      </div>

      <!-- 未登入按鈕組 -->
      <div v-else class="nav-buttons-group button-group">
        <router-link to="/sign-in" class="desktop-only">
          <div class="login-btn">{{ $t("navbar.login") }}</div>
        </router-link>
        <router-link to="/register">
          <div class="join-btn">{{ $t("navbar.register") }}</div>
        </router-link>

        <!-- 漢堡選單按鈕 (Mobile) -->
        <button
          type="button"
          class="menu-icon btn-reset"
          @click="isMobileMenuOpen = true"
          aria-label="開啟行動選單"
          title="開啟行動選單"
        >
          <MenuOutlined aria-hidden="true" />
        </button>
      </div>

      <div class="mobile-user-profile-btn" v-if="isLoggedIn">
        <div>
          <button
            type="button"
            class="btn-reset"
            aria-label="切換個人選單"
            @click="isMobileProfileMenuOpen = !isMobileProfileMenuOpen"
          >
            <img
              v-if="userData && userData.avatar"
              :src="userData.avatar"
              :alt="userData.name || '用戶頭像'"
              class="user-avatar"
            />
            <div
              v-else
              class="user-avatar-placeholder"
            >
              <UserOutlined />
            </div>
          </button>
        </div>
        <button
          type="button"
          class="menu-icon btn-reset"
          @click="isMobileMenuOpen = !isMobileMenuOpen"
          aria-label="開啟行動選單"
          title="開啟行動選單"
        >
          <MenuOutlined aria-hidden="true" />
        </button>
      </div>
    </div>

    <!-- 手機版個人資料選單 -->
    <MobileMenu
      v-if="isMobileProfileMenuOpen"
      :is-open="isMobileProfileMenuOpen"
      @update:is-open="isMobileProfileMenuOpen = $event"
      @menu-click="handleProfileMenuClick"
    />

    <!-- 手機版選單 -->
    <MobileNavigationMenu
      :is-open="isMobileMenuOpen"
      @update:is-open="isMobileMenuOpen = $event"
    />
  </nav>
</template>
  
  <script setup>
import { ref, computed, onMounted, onUnmounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { message } from "ant-design-vue";
import {
  DownOutlined,
  CloseOutlined,
  MenuOutlined,
  UserOutlined,
  DashboardOutlined,
  ReadOutlined,
  LogoutOutlined,
  BookOutlined,
  GlobalOutlined,
} from "@ant-design/icons-vue";
import { authAPI, PROJECT_WEBSITE_LINKS } from "../services/api";
import MobileMenu from "./MobileMenu.vue";
import MobileNavigationMenu from "./MobileNavigationMenu.vue";
import { useLayoutStore } from "../stores/layout";
import { SITE_NAME } from "../constants/site";

const router = useRouter();
const layoutStore = useLayoutStore();
const { locale } = useI18n();
const isMobileMenuOpen = ref(false);
const isMobileProfileMenuOpen = ref(false);
const showSubMenu = ref(false);
const userData = ref(null);
const isScrolled = ref(false);
const currentLocale = computed(() => locale.value);

// 下拉選單開關狀態管理（支援純鍵盤操控）
const dropdownOpen = ref({
  intro: false,
  standard: false,
  training: false,
  taiwan: false,
  project: false,
  user: false,
});

// 觸發按鈕鍵盤事件：按下 Enter、Space 或 ArrowDown 時打開選單並聚焦第一個項目
const handleTriggerKeyDown = (menuKey, event) => {
  if (['Enter', ' ', 'ArrowDown'].includes(event.key)) {
    event.preventDefault();
    dropdownOpen.value[menuKey] = true;
    nextTick(() => {
      const menuEl = document.querySelector(`.dropdown-menu[data-menu="${menuKey}"]`);
      if (menuEl) {
        const focusable = menuEl.querySelectorAll('a, button, [tabindex="0"]');
        if (focusable.length > 0) {
          focusable[0].focus();
        }
      }
    });
  } else if (event.key === 'Escape') {
    dropdownOpen.value[menuKey] = false;
  }
};

// 選單內部選項鍵盤事件：支援上下方向鍵輪替、Esc 關閉返回按鈕、Tab 移出時關閉
const handleMenuItemKeyDown = (menuKey, event) => {
  const menuEl = document.querySelector(`.dropdown-menu[data-menu="${menuKey}"]`);
  if (!menuEl) return;
  const focusable = Array.from(menuEl.querySelectorAll('a, button, [tabindex="0"]'));
  const currentIndex = focusable.indexOf(document.activeElement);

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    const nextIndex = (currentIndex + 1) % focusable.length;
    focusable[nextIndex].focus();
  } else if (event.key === 'ArrowUp') {
    event.preventDefault();
    const prevIndex = (currentIndex - 1 + focusable.length) % focusable.length;
    focusable[prevIndex].focus();
  } else if (event.key === 'Escape') {
    event.preventDefault();
    dropdownOpen.value[menuKey] = false;
    const triggerBtn = document.querySelector(`button[data-trigger="${menuKey}"]`);
    if (triggerBtn) triggerBtn.focus();
  } else if (event.key === 'Tab') {
    if (event.shiftKey && currentIndex === 0) {
      dropdownOpen.value[menuKey] = false;
      const triggerBtn = document.querySelector(`button[data-trigger="${menuKey}"]`);
      if (triggerBtn) triggerBtn.focus();
    } else if (!event.shiftKey && currentIndex === focusable.length - 1) {
      dropdownOpen.value[menuKey] = false;
    }
  }
};

const focusMainContent = (e) => {
  if (e) e.preventDefault();
  // 1. 優先尋找頁面主要內容錨點 #main-content
  let main = document.getElementById('main-content');

  // 2. 次選相容首頁舊錨點 #main-content-home 或最新消息
  if (!main) {
    main = document.getElementById('main-content-home') || document.getElementById('latest-news') || document.querySelector('.latest-news-section');
  }

  // 3. 若無，智慧偵測 Banner 之下緊鄰的主要內容區塊
  if (!main) {
    const banner = document.querySelector(
      '.banner-area, .light-blue-banner, .faq-banner-area, .activities-area, .sitemap-banner, .carousel-container, .hero-section, header.sitemap-banner'
    );
    if (banner && banner.nextElementSibling) {
      main = banner.nextElementSibling;
    }
  }

  // 4. 核心容器或主語意標籤
  if (!main) {
    main = document.querySelector(
      'main, .main-content, .content, .content-container, .find-container, .page-container, .register, .learning-page, .all-courses-page > :not(nav)'
    );
  }

  if (main) {
    main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: true });
    main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try {
      window.history.pushState(null, '', '#main-content');
    } catch (_) {}
  }
};

// 語言切換功能
function changeLanguage(lang) {
  locale.value = lang;
  localStorage.setItem("preferred-language", lang);
}

const isLoggedIn = computed(() => {
  return !!localStorage.getItem("ms_platform_token");
});

// 切換子選單
function toggleCollapse() {
  showSubMenu.value = !showSubMenu.value;
}

// 處理登出
async function handleLogout() {
  try {
    // 先呼叫後端登出 API
    await authAPI.logout();

    localStorage.removeItem("ms_platform_token");
    localStorage.removeItem("user_data");

    userData.value = null;

    isMobileMenuOpen.value = false;

    message.success("您已成功登出");

    // 使用頁面重新導向確保完全重新加載
    window.location.href = "/";
  } catch (error) {
    console.error("登出處理發生錯誤:", error);

    localStorage.removeItem("ms_platform_token");
    localStorage.removeItem("user_data");

    userData.value = null;

    message.warning("登出處理發生問題，但您已在本機登出");

    // 強制頁面重新加載
    window.location.href = "/";
  }
}

function handleScroll() {
  isScrolled.value = window.scrollY > 50;
  if (window.scrollY > 50) {
    document.body.classList.add("has-sticky-navbar");
  } else {
    document.body.classList.remove("has-sticky-navbar");
  }
}

async function fetchUserData() {
  try {
    console.log("開始獲取用戶資料...");
    const response = await authAPI.me();
    console.log("獲取用戶資料成功:", response.data);

    if (response.data) {
      userData.value = response.data;
      localStorage.setItem("user_data", JSON.stringify(response.data));
    } else {
      console.log("獲取用戶資料成功，但沒有數據");
    }
  } catch (error) {
    console.error("獲取用戶資料失敗:", error);
  }
}

// 載入用戶數據
const handleUserLoginSuccess = (event) => {
  console.log("收到登入成功事件，更新用戶資料");
  if (event.detail && event.detail.userData) {
    // 檢查 userData 的格式
    if (event.detail.userData.content) {
      userData.value = event.detail.userData.content;
    } else {
      userData.value = event.detail.userData;
    }
    console.log("從事件更新的用戶資料:", userData.value);
  }
};

// 修改 onMounted 函數
onMounted(() => {
  // 添加自定義事件監聽器
  window.addEventListener("user-login-success", handleUserLoginSuccess);

  const userDataStr = localStorage.getItem("user_data");
  if (userDataStr) {
    try {
      const parsedData = JSON.parse(userDataStr);
      userData.value = parsedData;
      console.log("從 sessionStorage 載入用戶資料成功:", userData.value);
    } catch (e) {
      console.error("解析用戶數據失敗:", e);
    }
  }

  // 如果有 token 但沒有用戶資料，則嘗試獲取
  if (!userData.value && isLoggedIn.value) {
    console.log("已登入但沒有用戶資料，嘗試獲取");
    fetchUserData();
  }

  window.addEventListener("scroll", handleScroll);
});

// 修改 onUnmounted 函數移除事件監聽器
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("user-login-success", handleUserLoginSuccess);
});

// 處理個人選單點擊
const handleProfileMenuClick = (path) => {
  isMobileProfileMenuOpen.value = false;
};
</script>
  
<style lang="scss" scoped>
/* ==================== 變數定義 (Variables) ==================== */
// 顏色
$color-white: #ffffff;
$color-black: #000000;
$color-primary-dark: #022964;
$color-primary-light: #1171dd;
$color-primary-deep: #383e93;
$color-accent: #6673ff;
$color-success: #00946a;
$color-danger: #ff4d4f;
$color-bg-light: #f5f5f5;
$color-bg-sub: #f9f9f9;
$color-bg-blue-light: #e9f1fe;
$color-border: #d9d9d9;
$color-border-light: #eee;
$color-border-dark: #ccc;

// 尺寸 (Base 16px)
$navbar-height: 7.6875rem; // 123px
$container-max-width: 75rem; // 1200px
$header-height: 3.625rem; // 58px
$announcement-height: 4.0625rem; // 65px
$btn-height: 2.75rem; // 44px
$btn-radius: 2.5rem; // 40px

// RWD Mixin
@mixin mobile {
  @media (max-width: 75rem) {
    // 1200px
    @content;
  }
}

/* ==================== 全局設定 ==================== */
:root {
  --navbar-height: #{$navbar-height};
}

// 頁面頂部推擠 (配合 Fixed Navbar)
.all-courses-page,
.next-gen-page,
.faq-page-wrapper,
.course-detail-view,
.learning-page,
.register {
  padding-top: var(--navbar-height);
}

/* ==================== Navbar 本體 ==================== */
.navbar {
  width: 100%;
  background-color: $color-white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: var(--navbar-height);
  transition: box-shadow 0.3s ease, background-color 0.3s ease;

  &.navbar-sticky {
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1); // 0 2px 10px
    background-color: rgba($color-white, 0.98);
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem; // 16px
  height: $header-height;
  max-width: $container-max-width;
}

/* ==================== 公告區塊 (Announcement) ==================== */
.announcement-banner {
  display: block;
  width: 100%;
  background: linear-gradient(
    90deg,
    #297776 0%,
    #6eb594 51%,
    #def3b0 75%,
    #fff9b9 100%
  );
  height: $announcement-height;
  overflow: hidden;
  text-decoration: none;

  @include mobile {
    height: auto;
    padding: 0.5rem 0; // 8px 0
  }
}

.announcement-content {
  max-width: $container-max-width;
  height: $announcement-height;
  margin: 0 auto;
  padding: 0 1rem; // 16px
  display: flex;
  align-items: center;
  gap: 0.625rem; // 10px
  color: $color-primary-dark;

  svg {
    flex-shrink: 0;
  }
}

.announcement-text {
  font-size: 1rem; // 16px
  font-weight: 700;
  color: $color-white;
  flex: 1;

  @include mobile {
    padding: 0.5rem 0; // 8px 0
    font-size: 0.875rem; // 14px
  }
}

.announcement-cta {
  margin-left: 0.75rem; // 12px
  font-size: 0.9375rem; // 15px
  font-weight: 600;
  color: $color-primary-dark;
  text-decoration: underline;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ==================== Logo 區域 ==================== */
.logo-section {
  display: flex;
  align-items: center;
  outline: none;
  margin-right: 0.625rem; // 10px
  gap: 4px;

  @media (max-width: 768px) {
    gap: 2px;
    margin-right: 0.25rem;

    .accesskey-brick {
      font-size: 0.75rem;
      padding: 0 2px;
      letter-spacing: 1px;
    }
  }

  img {
    height: auto;
    width: auto;
    outline: none;
    max-height: 2.8125rem; // 45px
  }
}

.logo-text {
  font-size: 0.9375rem; // 15px
  font-weight: 500;
  color: $color-black;
  margin-left: 0.25rem; // 4px
}

/* ==================== 桌機導覽列 (Desktop Nav) ==================== */
.nav-items {
  display: flex;
  gap: 1.25rem; // 20px
  align-items: center;
}

.nav-left {
  margin-left: 1.5rem; // 24px
  margin-right: auto;
}

.nav-right {
  margin-right: 1.5rem; // 24px
}

.nav-item {
  color: $color-black;
  font-size: 0.875rem; // 14px
  font-weight: 500;
  display: flex;
  align-items: center;
  text-decoration: none;

  &.disabled {
    color: #B5B5B5 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none;
    svg path {
      fill: #B5B5B5 !important;
    }
  }
}

/* ==================== 按鈕組 (Button Group) ==================== */
.button-group {
  display: flex;
  gap: 0.3125rem; // 5px
  font-size: 1rem; // 16px
  line-height: 2.5rem; // 40px
}

// 共用按鈕樣式
%btn-base {
  letter-spacing: normal;
  min-width: 4.5rem; // 72px
  text-align: center;
  height: $btn-height;
  border-radius: $btn-radius;
  border-width: 0.125rem; // 2px
  border-style: solid;
  transition: all 0.3s ease;

  &:hover {
    color: $color-white;
    background-color: $color-primary-light !important;
    border-color: $color-primary-light;
  }

  &:active {
    background-color: $color-primary-deep !important;
    border-color: $color-primary-deep;
    color: $color-white;
  }

  &:focus-visible {
    outline: 0.25rem solid $color-accent !important; // 4px
  }
}

.login-btn {
  @extend %btn-base;
  border-color: #1171dd;
  color: #1171dd;
  background-color: transparent;
}

.join-btn {
  @extend %btn-base;
  border-color: #1171dd;
  background-color: #1171dd;
  color: $color-white;
  width: 100%;
}

/* ==================== 用戶個人資料按鈕 (User Profile) ==================== */
.user-profile-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem; // 8px
  padding: 0.25rem 0.75rem 0.25rem 0.25rem; // 4px 12px 4px 4px
  border-radius: $btn-radius;
  color: $color-primary-dark;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 2.5rem; // 40px
}

.mobile-user-profile-btn {
  display: none;
  flex-direction: row-reverse; // 內部元素倒序
  justify-content: flex-start; // 反轉後靠右
  line-height: 2.75rem; // 44px
  gap: 0.625rem; // 10px

  @include mobile {
    display: flex;
  }
}

.user-avatar {
  width: 2rem; // 32px
  height: 2rem; // 32px
  border-radius: 50%;
  object-fit: cover;
  border: 0.0625rem solid $color-primary-dark; // 1px

  @include mobile {
    transform: translateY(0.3125rem); // 5px
  }
}

.user-avatar-placeholder {
  width: 2rem; // 32px
  height: 2rem; // 32px
  border-radius: 50%;
  background-color: $color-primary-dark;
  color: $color-white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem; // 16px

  @include mobile {
    transform: translateY(0.3125rem); // 5px
  }
}

.user-name {
  font-size: 0.875rem; // 14px
  font-weight: 500;
  color: $color-primary-dark;
}

/* ==================== 下拉選單 (Dropdown) ==================== */
.dropdown-trigger {
  cursor: pointer;
}

.dropdown-menu {
  background-color: $color-white;
  border-radius: 0.625rem; // 10px
  padding: 1rem; // 16px
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1); // 0 4px 12px
  width: 13.75rem; // 220px
  display: flex;
  flex-direction: column;
  gap: 1rem; // 16px
}

.project-websites-menu {
  width: 18rem; // 288px - wider for longer Chinese names
  max-height: 80vh;
  overflow-y: auto;
}

.dropdown-item {
  color: $color-black;
  font-size: 0.9375rem; // 15px
  font-weight: 500;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem; // 8px

  &:hover {
    color: $color-success;
    cursor: pointer;

    svg path {
      fill: $color-success;
    }
  }

  &.disabled {
    color: #B5B5B5 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none;
    svg path {
      fill: #B5B5B5 !important;
    }
  }
}

.dropdown-divider {
  height: 0.0625rem; // 1px
  background-color: $color-border-light;
  margin: 0.5rem 0; // 8px 0
}

.user-menu {
  width: 11.25rem; // 180px
}

/* ==================== 手機版個人選單 (Mobile Profile Menu) ==================== */
.mobile-profile-menu {
  position: fixed;
  top: var(--navbar-height);
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $color-white;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.mobile-profile-nav {
  padding: 1.25rem 0; // 20px 0
  display: flex;
  flex-direction: column;
}

.mobile-profile-item {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.5rem; // 10px 24px
  color: $color-black;
  text-decoration: none;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: $color-bg-light;
  }

  &.logout:hover {
    background-color: #fff2f0;
  }
}

.profile-item-icon {
  width: 1.25rem; // 20px
  height: 1.25rem; // 20px
  border-radius: 50%;
  margin-right: 1rem; // 16px
  flex-shrink: 0;
  border: 0.0625rem solid $color-black; // 1px
}

.profile-item-text {
  flex: 1;
  font-size: 1rem; // 16px
  font-weight: 400;
  text-align: left;
}

.profile-item-arrow {
  color: $color-black;
  font-size: 1.25rem; // 20px
  margin-left: auto;
}

.mobile-profile-divider {
  border: none;
  height: 0.0625rem; // 1px
  background-color: $color-border;
  margin: 1.3125rem 0; // 21px 0
}

/* ==================== 手機版主選單 (Mobile Main Menu) ==================== */
.menu-icon {
  font-size: 1.375rem; // 22px
  line-height: 2.5rem; // 40px
  display: none;
  cursor: pointer;
}

.mobile-menu {
  position: fixed;
  top: var(--navbar-height);
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: $color-white;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem; // 16px
  border-bottom: 0.0625rem solid $color-border; // 1px
}

.close-icon {
  font-size: 1.375rem; // 22px
  cursor: pointer;
}

.mobile-nav {
  padding: 1.875rem 0; // 30px 0
  display: flex;
  flex-direction: column;
  text-align: center;
}

.mobile-divider {
  height: 0.0625rem; // 1px
  background-color: $color-border;
  margin: 0.5rem 0; // 8px 0
}

.mobile-item {
  line-height: 2.75rem; // 44px
  font-size: 0.9375rem; // 15px
  color: $color-black;
  text-decoration: none;
  cursor: pointer;
  border-bottom: 0.0625rem solid $color-border-dark; // 1px
}

.sub-menu {
  display: flex;
  flex-direction: column;
}

.mobile-sub-item {
  line-height: 2.75rem; // 44px
  font-size: 0.9375rem; // 15px
  color: $color-black;
  text-decoration: none;
  border-bottom: 0.0625rem solid $color-border-dark; // 1px
  background: $color-bg-sub;
}

.mobile-buttons {
  width: 100%;
  background-color: $color-bg-blue-light;
  padding: 1.875rem; // 30px
  display: flex;
  flex-direction: column;
  gap: 1rem; // 16px
  box-sizing: border-box;
  margin-top: auto;

  .join-btn,
  .login-btn,
  .logout-btn {
    height: 2.5rem; // 40px
    border-radius: 2.5rem; // 40px
  }
}

.logout-btn {
  background-color: $color-danger;
  border: none;
  color: $color-white;
}

.global-icon {
  font-size: 1.25rem; // 20px
  margin-right: 0.25rem; // 4px
  vertical-align: middle;
}

.down-icon {
  width: 1.25rem; // 20px
  height: 1.25rem; // 20px
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem; // 12px
}

/* ==================== RWD 顯示控制 ==================== */
@include mobile {
  .desktop-only {
    display: none;
  }
  .menu-icon {
    display: block;
  }

  // Mobile nav buttons tweak
  .nav-buttons-group {
    div {
      height: 2rem; // 32px
      margin-top: 0.1875rem; // 3px
      line-height: 1.875rem; // 30px
    }

    .login-btn,
    .join-btn {
      font-size: 0.875rem; // 14px
    }
  }
}
</style>
